import React from 'react'
// import config from '../../config'
import format from '../../helpers/format'
// import { Link, LinkIcon } from '../'

const EsgConfig = {
  esgNamesLabels: [
    {
      label: 'Commodity producers',
      value: 'po_producer_weight',
    },
    {
      label: 'Banks and lenders',
      value: 'po_financier_weight',
    },
    {
      label: 'Major consumer brands',
      value: 'po_consumer_weight',
    }
  ],
  esgOptions: {
    po_producer_weight: {
      id: 'po_producer_weight',
      icon: 'icons_step4',
      fieldLabel: 'po_producer_weight',
      benchLabel: 'po_producer_weight',
      valueLabel: 'Commodity producers',
      direction: 'ascending',
      page: 'producer-investments',
      label: 'in commodity producers',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in commodity producers
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in commodity producers
          </span>
        )
      }
    }, 
    po_financier_weight: {
      id: 'po_financier_weight',
      icon: 'icons_step4',
      fieldLabel: 'po_financier_weight',
      benchLabel: 'po_financier_weight',
      valueLabel: 'Banks and lenders',
      direction: 'ascending',
      page: 'financier-investments',
      label: 'in banks and lenders',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in banks and lenders
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in banks and lenders
          </span>
        )
      }
    }, 
    po_consumer_weight: {
      id: 'po_consumer_weight',
      icon: 'icons_step4',
      fieldLabel: 'po_consumer_weight',
      benchLabel: 'po_consumer_weight',
      valueLabel: 'Major consumer brands',
      direction: 'ascending',
      page: 'consumer-investments',
      label: 'in major consumer brands',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in major consumer brands
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in major consumer brands
          </span>
        )
      }
    }, 
  }
}

export default EsgConfig